export default "__VITE_ASSET__CiSwv2Yx__"